import { Component, Input } from '@angular/core';
import {ParkInterface} from '@app/app/shared/interfaces/park.interface';
import * as moment from 'moment-timezone';

@Component({
  templateUrl: './park-statistic-activators.html',
  selector: 'park-statistic-activators'
})

export class ParkStatisticActivatorsComponent {
  @Input() park: ParkInterface;

  private getParkTz(park) {
    return ((park.attributes || {}).location || {}).timezone || 'UTC';
  }

  private scheduleTimeFormat() {
    const isAmPm = true;

    if (isAmPm) {
      return 'hh:mmA';
    } else {
      return 'HH:mm';
    }
  }

  public prepareDate(lastAct, data) {
    Object.keys(data).forEach(id => {
      const item = data[id];

      if (item.hasOwnProperty('lastActivations')) {
        const lastActivation = parseInt(item['lastActivations'] || -1, 10);

        if (lastActivation > 0 && moment(lastActivation, 'YY-MM-DD HH:mm:ss').valueOf() > moment(lastAct, 'YY-MM-DD HH:mm:ss').valueOf()) {
          lastAct = lastActivation;
        }
      }
    });

    return lastAct ? moment(lastAct, 'YY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : 'N/A'; //  20-08-04 12:08:36
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/statistic/activators/park-statistic-activators.component.ts